
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Link from "next/link";
import { useEffect, useState } from "react";

import useTranslation from "next-translate/useTranslation";

import { useRouter } from "next/router";

import { getCookie } from "cookies-next";
import moment from "moment";
import { useUser } from "../store/session";
import { priorities } from "@/shadcn/lib/utils";

const getPriorityName = (priority: string) => {
    return priorities.find((p) => p.id === priority.toLowerCase())?.name || priority;
};

export default function Home() {
    const router = useRouter();
    const { t } = useTranslation("nextmark");

    const { user } = useUser();
    const token = getCookie("session");

    const [hour, setHour] = useState<number>();
    const [openTickets, setOpenTickets] = useState(0);
    const [completedTickets, setCompletedTickets] = useState(0);
    const [unassigned, setUnassigned] = useState(0);
    const [uploaded, setUploaded] = useState(false);
    const [loading, setLoading] = useState(true);
    const [tickets, setTickets] = useState<any>();

    let file: any;

    async function time() {
        const date = new Date();
        const hour = date.getHours();
        setHour(hour);
    }

    async function getOpenTickets() {
        await fetch(`/api/v1/data/tickets/open`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => res.json())
            .then((res) => {
                setOpenTickets(res.count);
            });
    }

    async function getCompletedTickets() {
        await fetch(`/api/v1/data/tickets/completed`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => res.json())
            .then((res) => {
                setCompletedTickets(res.count);
            });
    }

    async function getUnassignedTickets() {
        await fetch(`/api/v1/data/tickets/unassigned`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => res.json())
            .then((res) => {
                setUnassigned(res.count);
            });
    }

    async function fetchTickets() {
        await fetch(`/api/v1/tickets/open`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => res.json())
            .then((res) => {
                console.log(res);
                setTickets(res.tickets);
            });
    }

    const stats = [
        { name: "Open Issues", stat: openTickets, href: "/issues" },
        {
            name: "Completed Issues",
            stat: completedTickets,
            href: "/issues?filter=closed",
        },
        {
            name: "Unassigned Issues",
            stat: unassigned,
            href: "/issues?filter=unassigned",
        },
    ];

    async function dataFetch() {
        Promise.all([fetchTickets(), getOpenTickets(), getCompletedTickets(), getUnassignedTickets()]);
        await setLoading(false);
    }

    useEffect(() => {
        time();
        dataFetch();
    }, []);

    return (
        <div className="flex flex-col justify-center w-full p-8 xl:flex-row">
            <div className="w-full xl:w-[70%] max-w-5xl">
                {!loading && (
                    <>
                        <div>
                            <dl className="grid grid-cols-1 gap-5 sm:grid-cols-3">
                                {stats.map((item, index) => (
                                    <Link href={item.href} key={`${item.href}-${index}`}>
                                        <div key={item.name} className="px-4 py-5 overflow-hidden bg-gray-900 rounded-lg shadow sm:p-6">
                                            <dt className="text-sm font-medium text-white truncate">{item.name}</dt>
                                            <dd className="mt-1 text-3xl font-semibold text-white">{item.stat}</dd>
                                        </div>
                                    </Link>
                                ))}
                            </dl>
                        </div>

                        <div className="flex flex-col w-full px-1 mt-4 mb-4">
                            {tickets !== undefined && tickets.length === 0 ? (
                                <>
                                    <button
                                        type="button"
                                        className="relative block w-full p-12 text-center border-2 border-gray-300 border-dashed rounded-lg hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                        onClick={() => {
                                            window.location.hash = "#!create-issue";
                                        }}>
                                        <svg className="w-12 h-12 mx-auto text-gray-400 dark:text-white" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M8 14v20c0 4.418 7.163 8 16 8 1.381 0 2.721-.087 4-.252M8 14c0 4.418 7.163 8 16 8s16-3.582 16-8M8 14c0-4.418 7.163-8 16-8s16 3.582 16 8m0 0v14m0-4c0 4.418-7.163 8-16 8S8 28.418 8 24m32 10v6m0 0v6m0-6h6m-6 0h-6"
                                            />
                                        </svg>
                                        <span className="block mt-2 text-sm font-semibold text-gray-900 dark:text-white">Create your first Issue</span>
                                    </button>
                                </>
                            ) : (
                                <>
                                    <span className="text-2xl font-bold">Recent Issues</span>
                                    <div className="w-full -mx-4 sm:-mx-0">
                                        <table className="min-w-full divide-y divide-gray-300">
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 dark:text-white sm:pl-0">
                                                        {t("title")}
                                                    </th>
                                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 dark:text-white sm:pl-0">
                                                        {t("Client")}
                                                    </th>
                                                    <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white lg:table-cell">
                                                        {t("priority")}
                                                    </th>
                                                    <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white sm:table-cell">
                                                        {t("status")}
                                                    </th>
                                                    <th scope="col" className="px-3 text-center py-3.5 text-sm font-semibold text-gray-900 dark:text-white">
                                                        {t("Attachments")}
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                        {t("created")}
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">
                                                        {t("assigned_to")}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200">
                                                {tickets !== undefined &&
                                                    tickets.slice(0, 10).map((item: any, index) => (
                                                        <tr
                                                            key={`${item.id}-${index}`}
                                                            className="hover:bg-gray-100 dark:hover:bg-green-600 hover:cursor-pointer"
                                                            onClick={() => router.push(`/issue/${item.id}`)}>
                                                            <td className="sm:max-w-[280px] 2xl:max-w-[720px] truncate py-1 pl-4 pr-3 text-sm font-medium text-gray-900 dark:text-white sm:pl-0">
                                                                {item.title}
                                                                <dl className="font-normal lg:hidden">
                                                                    <dt className="sr-only sm:hidden">Email</dt>
                                                                    <dd className="mt-1 text-gray-500 truncate sm:hidden">{item.email}</dd>
                                                                </dl>
                                                            </td>
                                                            <td className="hidden pr-1 py-1 text-sm text-gray-800 sm:table-cell w-[150px]">
                                                                <span className="block text-xs font-semibold">{item.client ? item.client.name : "-"}</span>
                                                                {item.clientMember ? <span className="block text-xs text-gray-500">{item.clientMember.name}</span> : "-"}
                                                            </td>
                                                            <td className="hidden px-3 py-1 text-sm text-gray-500 lg:table-cell w-[64px]">
                                                                {item.priority.toLowerCase() === "low" && (
                                                                    <span className="inline-flex justify-center w-full px-2 py-1 text-xs font-medium text-gray-700 rounded-md bg-gray-50 ring-1 ring-inset ring-gray-600/20">
                                                                        {getPriorityName(item.priority)}
                                                                    </span>
                                                                )}
                                                                {item.priority.toLowerCase() === "normal" && (
                                                                    <span className="inline-flex items-center justify-center w-full px-2 py-1 text-xs font-medium rounded-md text-lime-700 bg-lime-50 ring-1 ring-inset ring-lime-600/20">
                                                                        {getPriorityName(item.priority)}
                                                                    </span>
                                                                )}
                                                                {item.priority.toLowerCase() === "medium" && (
                                                                    <span className="inline-flex items-center justify-center w-full px-2 py-1 text-xs font-medium text-yellow-700 rounded-md bg-yellow-50 ring-1 ring-inset ring-yellow-600/20">
                                                                        {getPriorityName(item.priority)}
                                                                    </span>
                                                                )}
                                                                {item.priority.toLowerCase() === "high" && (
                                                                    <span className="inline-flex items-center justify-center w-full px-2 py-1 text-xs font-medium text-orange-700 rounded-md bg-orange-50 ring-1 ring-inset ring-orange-600/20">
                                                                        {getPriorityName(item.priority)}
                                                                    </span>
                                                                )}
                                                                {item.priority.toLowerCase() === "critical" && (
                                                                    <span className="inline-flex items-center justify-center w-full px-2 py-1 text-xs font-medium text-red-700 rounded-md bg-red-50 ring-1 ring-inset ring-red-600/20">
                                                                        {getPriorityName(item.priority)}
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td className="hidden px-3 py-1 text-sm text-gray-500 sm:table-cell w-[64px]">
                                                                {item.isComplete === true ? (
                                                                    <div>
                                                                        <span className="inline-flex items-center gap-x-1.5 rounded-md bg-red-100 px-2 py-1 text-xs font-medium text-red-700">
                                                                            <svg className="h-1.5 w-1.5 fill-red-500" viewBox="0 0 6 6" aria-hidden="true">
                                                                                <circle cx={3} cy={3} r={3} />
                                                                            </svg>
                                                                            {t("closed")}
                                                                        </span>
                                                                    </div>
                                                                ) : (
                                                                    <>
                                                                        <span className="inline-flex items-center gap-x-1.5 rounded-md bg-green-100 px-2 py-1 text-xs font-medium text-green-700">
                                                                            <svg className="h-1.5 w-1.5 fill-green-500" viewBox="0 0 6 6" aria-hidden="true">
                                                                                <circle cx={3} cy={3} r={3} />
                                                                            </svg>
                                                                            {t("open")}
                                                                        </span>
                                                                    </>
                                                                )}
                                                            </td>
                                                            <td className="px-3 py-1 text-center text-sm text-gray-500 w-[130px] dark:text-white truncate whitespace-nowrap">
                                                                {item._count.TicketFile ? `(${item._count.TicketFile})` : "--"}
                                                            </td>
                                                            <td className="px-3 py-1 text-sm text-gray-500 dark:text-white w-[110px]">
                                                                {moment(item.createdAt).format("DD/MM/YYYY HH:SS a")}
                                                            </td>
                                                            <td className="px-3 py-1 text-sm text-gray-500 w-[130px] dark:text-white truncate whitespace-nowrap">
                                                                {item.assignedTo ? item.assignedTo.name : "-"}
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  